import $ from 'jquery';
import * as common from '../../../shared/modules/common';

/**
 * A primary button is by default the button that gets triggered if one hits enter with the focus on an input field.
 */
export function init(callback) {
    var focusableSelector = [
            'button',
            'input[type="text"]',
            'input[type="password"]',
            'input[type="radio"]',
            'input[type="checkbox"]',
            'select'
        ].join(',');

    $(focusableSelector).keydown(function (e) {
        var keydownResult;
        if (e.keyCode === 13) {
            var $parentForm = $(this).closest('form'),
                $defaultButtonsInForm = $('.uwr-default-button', $parentForm);
            if ($defaultButtonsInForm.length) {
                $defaultButtonsInForm.click();
                keydownResult = false;
            } else {
                keydownResult = true;
            }
            return keydownResult;
        }
    });

    common.invoke(callback);
}



//////////////////
// WEBPACK FOOTER
// ./widgets/DefaultButton/js/defaultButton.js
// module id = 30
// module chunks = main